export const API_CHECK_USERNAME = "/auth/check-username";
export const API_LOGIN = "/auth/admin-login";
export const API_FORGOT_PASSWORD = "/auth/forgot-password";
export const API_RESET_PASSWORD = "/auth/reset-password";
export const API_GET_USER_PROFILE = "/admin/profile";
export const API_GET_USERS = "/admin/users";
export const API_GET_RECIPES = "/admin/recipes";
export const API_PUT_USERS = "/admin/users";
export const API_REFRESH_TOKEN = "/auth/refresh-token";